<script setup>
// Reusable row-action icon button for admin list tables. Renders the shared
// global .tl-iconbtn (settings.scss) wrapped in a v-tooltip so every list icon
// gets a consistent hover tooltip instead of the native `title` attribute.
defineProps({
  tooltip: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    required: true
  },
  iconSize: {
    type: [Number, String],
    default: 17
  },
  danger: {
    type: Boolean,
    default: false
  },
  location: {
    type: String,
    default: 'top'
  },
  /** Greyed and inert. */
  disabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(['click']);
</script>

<template>
  <v-tooltip :text="tooltip" :location="location">
    <template #activator="{ props }">
      <button
          v-bind="props"
          :aria-label="tooltip"
          type="button"
          class="tl-iconbtn"
          :class="{ 'tl-iconbtn--danger': danger, 'tl-iconbtn--disabled': disabled }"
          :disabled="disabled"
          :aria-disabled="disabled || undefined"
          @click="!disabled && emit('click')"
      >
        <v-icon :size="iconSize">{{ icon }}</v-icon>
      </button>
    </template>
  </v-tooltip>
</template>
